import React from 'react';

import Table, {Cell, Head} from '@pb/kit-component-table';

import {MCP_CONTRACT_CELL_WIDTH as WIDTH} from '../constants';

import {mcpContractListHeader, mcpContractListHeaderColumns, mcpContractListHeaderSpacer} from './contract-list-header.module.styl';

type Props = {
    isPastContract?: boolean,
};

export const ContractListHeader = ({isPastContract}: Props) => {
    return (
        <div className={mcpContractListHeader}>
            <div className={mcpContractListHeaderSpacer}/>
            <div className={mcpContractListHeaderColumns}>
                <Table>
                    <Head>
                        <Cell width={WIDTH.contract}>Contract #</Cell>
                        <Cell {...{className: 'text-align_center', width: WIDTH.startDate}}>Start Date</Cell>
                        <Cell {...{className: 'text-align_center', width: WIDTH.endDate}}>End Date</Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.credits}}>Credits</Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.overages}}>Overages</Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.remainingCredits}}>
                            {isPastContract ? 'Expired' : 'Remaining'} Credits
                        </Cell>
                        <Cell {...{className: 'text-align_right', width: WIDTH.remainingOverages}}>
                            {isPastContract ? 'Expired' : 'Remaining'} Overages
                        </Cell>
                    </Head>
                </Table>
            </div>
        </div>
    );
};
